"use strict";

define('libs/visual.search.helper',['backbone', 'appkit/spf.helper', 'model/autocomplete', 'uikit/uikit'], function (Backbone, SPFHelper, AutoComplete, UIKit) {
  var VSToken = UIKit.TokenInput.Token;
  var AUTO_COMPLETE_LIMIT = 6;
  var SAME_VALUE_TO_PREVENT_SORTING_BY_DISPLAY_ORDER = 0;
  var encodedCharReplacements = [{
    symbol: '+',
    encoded: '%2B',
    replacement: 'PLUS_SIGN'
  }, {
    symbol: '%',
    encoded: '%25',
    replacement: 'PERCENT_SIGN'
  }];
  var VisualSearchHelper = {
    applyEncodingReplacements: function applyEncodingReplacements(encodedValue) {
      encodedCharReplacements.forEach(function (mapping) {
        var _encodedValue;
        var regex = new RegExp(mapping.encoded, 'g');
        encodedValue = (_encodedValue = encodedValue) === null || _encodedValue === void 0 ? void 0 : _encodedValue.replace(regex, mapping.replacement);
      });
      return encodedValue;
    },
    bindFilterVisualSearch: function bindFilterVisualSearch(vs, filterModel, fields) {
      var autoCompleteMap = {},
        sortMap = {},
        existingFilter = null,
        existingFilters = [],
        eventBus = _.extend({}, Backbone.Events),
        self = this;
      for (var i = 0, numOfFields = fields.length; i < numOfFields; i++) {
        var field = fields[i];
        autoCompleteMap[field.displayName] = field.autoComplete;
        sortMap[field.displayName] = field.sortName || 'description';
        existingFilter = filterModel.get(field.name);
        var processNonDateFilter = function processNonDateFilter(existingFilter) {
          existingFilter = existingFilter.split('|');
          for (var j = 0, numOfValues = existingFilter.length; j < numOfValues; j++) {
            existingFilters.push({
              text: field.displayName,
              value: existingFilter[j]
            });
          }
        };
        var processDateFilter = function processDateFilter(existingFilter) {
          existingFilters.push({
            text: field.displayName,
            dateType: 'true',
            fromDate: existingFilter.fromDate,
            toDate: existingFilter.toDate
          });
        };
        if (existingFilter) {
          if (existingFilter.dateType) {
            processDateFilter(existingFilter);
          } else {
            processNonDateFilter(existingFilter);
          }
        }
      }
      eventBus.listenTo(vs, 'render', function () {
        vs.addClass('icon');
      });
      vs.collection = new Backbone.Collection(existingFilters, {
        model: VSToken
      });
      vs.fieldResultsView.childBindings.text = 'displayName';
      var searchAll = _.findWhere(fields, {
        name: 'q'
      });
      if (searchAll) {
        vs.fieldResultsView["default"] = searchAll.displayName;
      }
      var announceFieldResults = function announceFieldResults(itemsCount, totalCount) {
        var message = itemsCount !== 0 ? itemsCount + ' of ' + totalCount + ' search fields showing ' : 'No matches found';
        vs.fieldResultsView.announcer.show();
        vs.fieldResultsView.announcer.text = message;
        _.debounce(vs.fieldResultsView.announcer.hide);
      };
      eventBus.listenTo(vs, 'search:field', function (text) {
        var filteredFields = _.chain(fields).filter(function (field) {
          return field.displayName.toLowerCase().indexOf(text.toLowerCase()) != -1;
        }).sortBy(function (field) {
          return field.displayName;
        }).sortBy(function (field) {
          if (field.displayOrder) {
            return field.displayOrder;
          }
          ;
          return SAME_VALUE_TO_PREVENT_SORTING_BY_DISPLAY_ORDER;
        }).value();
        vs.fieldResultsView.collection = new Backbone.Collection(filteredFields);
        announceFieldResults(filteredFields.length, fields.length);
      });
      vs.tokenResultsView.childBindings.text = 'description';
      var spfHelper = null;
      var addFooter = function addFooter() {
        if (vs.collection.models && vs.collection.models[0] && !(autoCompleteMap[vs.collection.models[0].attributes.text] instanceof Backbone.Collection)) {
          var itemsCount = spfHelper.collection.length,
            totalCount = spfHelper.paginate.get('totalElements'),
            remainingCount = totalCount - itemsCount;
          if (vs.selected && vs.selected.text == 'Analyst') {
            var unassignedModel = vs.tokenResultsView.collection.findWhere({
              description: 'Unassigned'
            });
            if (unassignedModel) {
              totalCount += 1;
              remainingCount = totalCount - itemsCount;
            }
          }
          if (!remainingCount || !itemsCount) {
            vs.tokenResultsView.hideFooter();
          } else {
            vs.tokenResultsView.showFooter({
              count: itemsCount + ' of ' + totalCount,
              text: 'View More'
            });
          }
        }
      };
      var announceTokenResults = function announceTokenResults() {
        var itemsCount = spfHelper.collection.length,
          totalCount = spfHelper.paginate.get('totalElements'),
          message = itemsCount !== 0 ? itemsCount + ' of ' + totalCount + ' matches showing ' : 'No matches found';
        vs.tokenResultsView.announcer.show();
        vs.tokenResultsView.announcer.text = message;
        _.debounce(vs.tokenResultsView.announcer.hide);
      };
      eventBus.listenTo(vs, 'search:value', function (value, field) {
        if (autoCompleteMap[field] instanceof Backbone.Collection) {
          var filtered = autoCompleteMap[field].filter(function (model) {
            if (value) {
              return String(model.get('description')).toLowerCase().indexOf(value.toLowerCase()) >= 0;
            }
            return true;
          });
          if (!vs.tokenResultsView.collection) {
            vs.tokenResultsView.collection = new Backbone.Collection();
          }
          vs.tokenResultsView.collection.reset(filtered);
        } else if (!(autoCompleteMap[field] instanceof Backbone.Collection) && autoCompleteMap[field]) {
          if (!vs.tokenResultsView.collection) {
            vs.tokenResultsView.collection = AutoComplete.collection(autoCompleteMap[field]);
            if (field === 'Analyst') {
              eventBus.listenTo(vs.tokenResultsView.collection, 'sync', function (collection, resp, options) {
                var unassignedModel = collection.findWhere({
                    description: 'Unassigned'
                  }),
                  searchValue = vs.selected ? vs.selected.detail : '';
                if (!searchValue) searchValue = '';
                if (unassignedModel) {
                  collection.remove(unassignedModel);
                }
                if ('unassigned'.indexOf(searchValue.toLowerCase()) >= 0) {
                  collection.add({
                    description: 'Unassigned'
                  });
                }
              });
            }
            spfHelper = new SPFHelper(vs.tokenResultsView.collection);
          } else {
            vs.tokenResultsView.collection.params(autoCompleteMap[field]);
            spfHelper.paginate.set('page', 1);
            self._currentValue = value;
          }
          if (sortMap[field]) {
            spfHelper.sort.set('sort', sortMap[field]);
          }
          vs.tokenResultsView.collection.fetch({
            data: {
              size: AUTO_COMPLETE_LIMIT,
              q: VisualSearchHelper.applyEncodingReplacements(encodeURIComponent(value))
            }
          });
          vs.tokenResultsView.collection.on('sync', announceTokenResults);
          eventBus.listenToOnce(vs.tokenResultsView, 'render:collection add:child', _.debounce(function () {
            if (!(autoCompleteMap[field] instanceof Backbone.Collection)) {
              addFooter();
            }
          }));
        }
        self._currentValue = value;
      });
      eventBus.listenTo(vs, 'search:press:footer', function () {
        spfHelper.incrementPage();
        spfHelper.fetch({
          remove: false,
          data: {
            size: AUTO_COMPLETE_LIMIT,
            q: self._currentValue
          }
        });
        eventBus.listenTo(vs.tokenResultsView, 'add:child', _.debounce(addFooter));
      });
      var generateTokenFilters = function generateTokenFilters() {
        var tokensByProperty = function tokensByProperty(property) {
          return vs.collection.filter(function (t) {
            return t.get('text') == property;
          });
        };
        for (var i = 0, filterPropsLen = fields.length; i < filterPropsLen; i++) {
          var _value, _prop, _prop2, _prop3;
          var prop = fields[i],
            value = undefined,
            tokens = tokensByProperty(prop.displayName);
          if (!_.isEmpty(tokens)) {
            for (var j = 0, tokensLen = tokens.length; j < tokensLen; j++) {
              if (tokens[j].get('dateType')) {
                value = {
                  dateType: 'true',
                  fromDate: tokens[j].get('fromDate'),
                  toDate: tokens[j].get('toDate')
                };
                break;
              } else {
                if (tokens[j].get('value')) {
                  value = (value ? value + '|' : '') + tokens[j].get('value');
                }
              }
            }
          }
          if (((_value = value) === null || _value === void 0 ? void 0 : _value.dateType) === 'true' || ((_prop = prop) === null || _prop === void 0 ? void 0 : _prop.name) === 'expirationDate' || ((_prop2 = prop) === null || _prop2 === void 0 ? void 0 : _prop2.name) === 'adminCheckinDate' || ((_prop3 = prop) === null || _prop3 === void 0 ? void 0 : _prop3.name) === 'finalizedDate') {
            filterModel.set(prop.name, value);
          } else {
            var encodedValue = encodeURIComponent(value);
            var encodedValueOnReplacement = VisualSearchHelper.applyEncodingReplacements(encodedValue);
            filterModel.set(prop.name, value ? encodedValueOnReplacement : value);
          }
        }
      };
      eventBus.listenTo(vs, 'token:remove token:add token:revised', function (token) {
        generateTokenFilters();
      });
      return eventBus;
    }
  };
  return VisualSearchHelper;
});

